import React from 'react';

export interface PackageInterface {
  item_type: string;
  id: number;
  client_id: number;
  client_name: string;
  name: string;
  store_id: number;
  store_name: string;
  exp_date: string;
  units_total: number;
  units: number;
  price: string;
  tmpl_id: number;
  billing_dt: string | null;
  sys_dt: string;
  allow_ordering: number;
  state: number;
  category_name: string;
  package_sharing_type: number;
  descr_public: string;
  descr_public_long: string;
  footer: string;
  comment_for_client: string;
  receipt_url?: string | null;
}

export interface PackageItem {
  svc_num: number;
  svc_name: string;
  copay: string;
  release_meth: string;
  exp_meth: string;
  exp_date: null | string;
  val: string;
  init_qty: number;
  used_qty: number;
  usable_qty: number;
  req_provider: boolean;
  req_resource: boolean;
}

export interface PromoLabelInterface {
  pkg_label_id: number;
  img: string;
  title: string;
  description: string;
}

export interface PromoInterface {
  active_promo: boolean;
  title_img: string;
  banner_img: string;
  tile_img: string;
  title: string;
  description: string;
  fine_print: string;
  promo_labels: PromoLabelInterface[];
}

export interface ShopItemInterface extends PromoLabelInterface {
  linkUrl?: string;
  image?: { mobile: string; desktop: string };
  isExternal?: boolean;
  mobileBaseHeight?: number;
  mobileSmHeight?: number;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export enum PackagePurchaseStep {
  LOCATION,
  PACKAGES_LIST,
  DETAILS,
  PAYMENTS,
  FINAL
}

export enum PackageListType {
  ACTIVE = 'active',
  EXPIRED = 'expired'
}
